import { render, staticRenderFns } from "./ExPositionPickerV2.vue?vue&type=template&id=ec472604&scoped=true"
import script from "./ExPositionPickerV2.vue?vue&type=script&lang=js"
export * from "./ExPositionPickerV2.vue?vue&type=script&lang=js"
import style0 from "./ExPositionPickerV2.vue?vue&type=style&index=0&id=ec472604&prod&lang=css"
import style1 from "./ExPositionPickerV2.vue?vue&type=style&index=1&id=ec472604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec472604",
  null
  
)

export default component.exports